import env from './env';

export default {
  apiKey: env('GOOGLE_API_KEY', ''),
};
